import PropTypes from '../_util/vue-types';

export default {
  name: 'ATableColumnGroup',
  props: {
    fixed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),
    title: PropTypes.any
  },
  __ANT_TABLE_COLUMN_GROUP: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/table/ColumnGroup.js
// module id = null
// module chunks = 